
import { z, ZodError, } from 'zod';
export const memberSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.email("Please enter an email in the format: name@example.com"),
});

export interface MailchimpFormValues {
  firstName: string,
  lastName: string,
  email: string
}


export type MailchimpFormState = {
  status: string,
  message: string,
  errors?: ZodError
}

